import { AgGridReact } from "ag-grid-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { FaFilter } from "react-icons/fa"; // Example using react-icons
import ReportCustomFilter from "./ReportCustomFilter";
import StatusBarPagination from "./Report/StatusBarPagination";

const AgGridReportComponent = ({ rows, columns, getTodalDisplayCount }) => {
  const para = useParams();

  const history = useHistory();
  const [state, setState] = useState({
    columnDefs: [],
    rows: [],
  });
  let menuButton = useRef(null);
  const gridOptions = useRef({
    pagination: false, // Disable default pagination
    paginationPageSize: 10, // Set default page size
  });

  const [currentPage, setCurrentPage] = useState(0); // Keep track of the current page
  const [pageSize, setPageSize] = useState(10); // Keep track of page size

  const goToPage = (pageNum) => {
    gridOptions.current.api.paginationGoToPage(pageNum);
    setCurrentPage(pageNum); // Update the current page
  };

  const nextPage = () => {
    const nextPage = currentPage + 1;
    gridOptions.current.api.paginationGoToPage(nextPage);
    setCurrentPage(nextPage); // Update the current page
  };

  const prevPage = () => {
    const prevPage = currentPage - 1;
    gridOptions.current.api.paginationGoToPage(prevPage);
    setCurrentPage(prevPage); // Update the current page
  };

  const handlePageSizeChange = (e) => {
    const newSize = Number(e.target.value);
    setPageSize(newSize);
    gridOptions.current.api.paginationSetPageSize(newSize); // Change the page size
  };

  useEffect(() => {
    const formatcolumns = formatColumns(columns || []);

    setState((state) => {
      return {
        ...state,
        defaultColDef: {
          ...state.defaultColDef,
          menuTabs: ["filterMenuTab"],
          headerComponent: (params) => customerHeaderCall(params),
        },
        columnDefs: [...formatcolumns],
        rows: rows,
      };
    });
  }, [columns, rows]);

  const setFilterRows = (e, pid, val, type, attribute_set_key) => {
    e.preventDefault();

    var default_arr = [];
    default_arr = {
      pod_department: [pid],
      ...val,
    };

    let final_filter_val = default_arr;

    let newfilter = JSON.stringify(final_filter_val);
    let filterTosearch = {};
    filterTosearch = {
      ...filterTosearch,
      [attribute_set_key]: newfilter,
    };
    if (filterTosearch) {
      let queryString = Object.values(filterTosearch)
        .map((obj) => new URLSearchParams(obj).toString())
        .join("&");
      if (queryString.endsWith("=")) {
        queryString = queryString.slice(0, -1);
      }
      history.push(
        `/tattle/${para.attribute_set_key}/${type}?type=${para.backlog}&q=` +
        queryString
      );
    }
  };

  const getQueryParams = (lastData = null, val) => {
    console.log(lastData, val, 2342432453243);
    // return;
    let conststring = {};

    conststring = {
      ...conststring,
      // pod_department: [podId],
      ...val,
    };

    if (lastData) {
      conststring = {
        ...conststring,
        [Object.keys(lastData)[0]]: [Object.values(lastData)[0]],
      };
    }

    const filterval = JSON.stringify({ ...conststring });

    const queryParams = {
      q: filterval, // This is already a JSON string
    };

    const queryString = Object.keys(queryParams)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`
      )
      .join("&");

    return `?${queryString}`;
  };
  const onMenuClicked = (params, event) => {
    const check = document.querySelector(`[col-id="${params.column.colId}"]`);
    params.showColumnMenu(check);
  };

  const filterCheckforanyvalue = (val, field) => {
    const check = document.querySelector(`[col-id="${field}"]`);

    const svgElement = check ? check.querySelectorAll("svg path") : null;
    console.log(svgElement, 2324234324324);
    if (val.length === 0) {
      if (svgElement) {
        svgElement.forEach((path) => {
          path.style.stroke = "gray"; // Change stroke color
          path.style.fill = "gray"; // Change fill color
        });
      }
    }
  };

  const onSortRequested = (params) => {
    if (params?.column?.sort === "none") {
      params.setSort("asc");
    } else if (params?.column?.sort === "desc") {
      params.setSort("asc");
    } else {
      params.setSort("desc");
    }
  };

  const customerHeaderCall = (params) => {
    console.log(params, 345243243242);
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          width: "100%",
          justifyContent: "space-between",
        }}
        className="customHeaderLabel"
        ref={(menuButton) => {
          menuButton = menuButton;
        }}
      >
        <div style={{ display: "flex" }}>
          <span>{params.displayName}</span>
          {console.log(params, 23432432432432)}

          <div className="arrow-chevron">
            <div
              className="sorting-custom"
              onClick={() => onSortRequested(params)}
            >
              {params?.enableSorting && (
                <>
                  <span
                    className={`customSortDownLabel sorttt ${
                      params.column.sort === "asc" ? "notdisaplay" : ""
                    } desc${params.column.sort === "desc" ? "descactive" : ""}`}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 11.0833V2.91663"
                        stroke="black"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.9165 6.99996L6.99984 2.91663L11.0832 6.99996"
                        stroke="black"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span
                    className={`customSortUpLabel sorttt asc${
                      params.column.sort === "asc" ? "ascactive" : ""
                    }`}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 2.91671L7 11.0834"
                        stroke="black"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M11.0835 7.00004L7.00016 11.0834L2.91683 7.00004"
                        stroke="black"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </>
              )}
            </div>
          </div>
        </div>

        {params.column?.colDef?.is_filter && (
          <svg
            width="16"
            height="44"
            viewBox="0 0 16 44"
            xmlns="http://www.w3.org/2000/svg"
            class="filter-svg"
            onClick={() => onMenuClicked(params, menuButton)}
          >
            <path
              d="M1 18H15"
              stroke="gray"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="gray"
            ></path>
            <path
              d="M3.5 22H12.5"
              stroke="gray"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="gray"
            ></path>
            <path
              d="M6.5 26H9.5"
              stroke="gray"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="gray"
            ></path>
          </svg>
        )}
      </div>
    );
  };

  // customize each column and render value accordingly

  const formatColumns = useCallback(
    (column) => {
      let columnsNewDef = [];

      column.forEach((item) => {
        console.log(item, 2334353454332);
        let columndefs = {
          ...item,
          cellClass: "wrap-text",
          filter: item?.is_filter,
          getHeaderClass: (params) => {
            return params.column.isFilterActive() ? "active-filter" : "";
          },
          sortable: item?.sortable,
        };
        if (item.field_type === "select") {
          console.log(item, 434323421323);
          let itemnew = {
            ...columndefs,

            filter: ReportCustomFilter,
            filterParams: {
              filterCheckforanyvalue: filterCheckforanyvalue,
              debounceMs: 500, // Optional: Add a debounce effect for the filter input
            },
            cellRenderer: (params) => {
              const { options, viewType } = params.colDef;
              const customvalue = options.find(
                (it) => it.id === params.value
              )?.value;
              if (item.has_redirection) {
                if (item.viewType === "detail") {
                  return (
                    <a
                      class="backlog-a"
                      href={`${window.location.origin}/tattle/${item.attribute_set_key}/${params.value}`}
                    >
                      {customvalue}
                    </a>
                  );
                }
                return item?.field_link ? (
                  <a
                    class="backlog-a"
                    onClick={(e) =>
                      setFilterRows(
                        e,
                        params.value,
                        params.colDef.field_link,
                        viewType,
                        item.attribute_set_key
                      )
                    }
                  >
                    {customvalue}
                  </a>
                ) : (
                  { customvalue }
                );
              } else {
                return item?.field_link ? (
                  <a class="backlog-a" onClick={(e) => e.preventDefault()}>
                    {customvalue}
                  </a>
                ) : (
                  { customvalue }
                );
              }
            },
            comparator: (valueA, valueB, nodeA, nodeB) => {
              const options = item.options; // Get the select options

              // Convert IDs to display text
              const textA = options.find((it) => it.id === valueA)?.value || "";
              const textB = options.find((it) => it.id === valueB)?.value || "";

              return textA.localeCompare(textB); // Sort alphabetically based on text
            },
          };
          columnsNewDef.push(itemnew);
        } else if (
          item.field === "type_customer" ||
          item.field === "type_internal"
        ) {
          const { viewType } = item;
          let itemnew = {
            ...columndefs,

            cellRenderer: (params) => {
              const { data } = params;
              return getRedirectionLink(item, viewType, data, params);
            },
          };
          columnsNewDef.push(itemnew);
        } else if (item.field === "total") {
          let itemnew = {
            ...columndefs,

            cellRenderer: (params) => {
              const { data } = params;

              return params.value;
            },
          };
          columnsNewDef.push(itemnew);
        } else if (item.field_category == "effort") {
          const { viewType } = item;
          let itemnew = {
            ...columndefs,

            cellRenderer: (params) => {
              console.log(params, item, 434323421323);
              const { data } = params;
              let value = params?.value;
              console.log(value, 34343423423);
              let hhmm;
              if (value != 0 && value > 8) {
                value = value / 8;

                if (!Number.isInteger(value)) {
                  const hours = Math.floor(value); // Get only the integer part
                  console.log(hours, 23432424234);
                  hhmm = hours ? hours + " D  " : "";
                } else {
                  hhmm = value ? value + " D  " : "";
                }

                // Extract the decimal part
                const decimalPart = value - Math.floor(value);

                const decimalHour = Math.floor(decimalPart * 10);
                console.log(decimalHour, 23432424234);

                console.log(decimalHour); // Output: 6
                if (decimalHour) {
                  hhmm += decimalHour ? decimalHour + " H" : "";
                  console.log(hhmm, 23432424234);
                }
              } else {
                hhmm = value ? value + " H" : "";
              }

              return getRedirectionLink(item, viewType, data, params, hhmm);
            },
          };
          columnsNewDef.push(itemnew);
        } else {
          const { viewType } = item;
          let itemnew = {
            ...columndefs,
            cellRenderer: (params) => {
              console.log(params, item, 434323421323);
              const { data } = params;

              return getRedirectionLink(item, viewType, data, params);
            },
          };
          columnsNewDef.push(itemnew);
        }
      });

      return columnsNewDef;
    },
    [columns]
  );

  const getRedirectionLink = (item, viewType, data, params, effort = null) => {
    console.log(item, viewType, data, 323443242321);
    const firstColumn = params.columnApi.getAllColumns()[0];
    const firstColDef = params.columnApi
      .getColumn(firstColumn.getColId())
      .getColDef();
    console.log("First Column Definition:", firstColDef, 2332343543543);

    const firstColId = params.columnApi.getAllColumns()[0].getColId();
    const firstColValue = params.data?.[firstColId];
    console.log("First Column Value:", firstColValue, 2332343543543);

    if (item.has_redirection) {
      if (item.hasOwnProperty("page_url") && item.page_url) {
        console.log(item.page_url, item, 233445353534);
        return (
          <a
            class="backlog-a"
            href={`${item.page_url}?q=${encodeURI(
              JSON.stringify({
                [firstColDef?.field]: [firstColValue],
              })
            )}`}
            target="_blank"
          >
            {effort || params.value}
          </a>
        );
      }
      return (
        <Link
          class="backlog-a"
          to={{
            pathname: `/tattle/${item.attribute_set_key}/${viewType}`,
            search: getQueryParams(
              {
                [firstColDef?.field]: firstColValue,
              },
              params.colDef.field_link
            ),
          }}
        >
          {effort || params.value}
        </Link>
      );
    } else {
      return <span>{effort || params.value}</span>;
    }
  };
  const handleProcessCellForClipboard = (params) => {
    console.log(params, 223432432432);
    const { colDef } = params?.column;

    let type = colDef.hasOwnProperty("field_category")
      ? colDef.field_category
      : colDef?.field_type;

    switch (type) {
      case "select": {
        const { options } = colDef;

        const val = options?.find(
          (item) => (item._id || item.id) === params.value
        );
        return val?.option_name || val?.name || val?.value;
      }

      case "effort":
        let effort;
        const { data } = params;
        let value = params?.value;
        console.log(value, 34343423423);

        if (value != 0 && value > 8) {
          value = value / 8;

          if (!Number.isInteger(value)) {
            const hours = Math.floor(value); // Get only the integer part
            console.log(hours, 23432424234);
            effort = hours ? hours + " D  " : "";
          } else {
            effort = value ? value + " D  " : "";
          }

          // Extract the decimal part
          const decimalPart = value - Math.floor(value);

          const decimalHour = Math.floor(decimalPart * 10);

          if (decimalHour) {
            effort += decimalHour ? decimalHour + " H" : "";
          }
        } else {
          effort = value ? value + " H" : "";
        }

        return effort;
        break;
      default:
        return params.value;
        break;
    }
  };

  return (
    <>
      <AgGridReact
        rowData={state.rows}
        gridOptions={gridOptions.current}
        columnDefs={state.columnDefs}
        suppressContextMenu={true}
        suppressMenu={true}
        defaultColDef={state.defaultColDef}
        enableClipboard={true}
        enableRangeSelection={true}
        copyHeadersToClipboard={true}
        pagination={true} // Enable pagination
        suppressPaginationPanel={true}
        processCellForClipboard={handleProcessCellForClipboard}
        paginationPageSize={20}
        statusBar={{
          statusPanels: [
            {
              statusPanel: StatusBarPagination, // Use the custom pagination component
              align: "right",
              statusPanelParams: {
                updateCount: getTodalDisplayCount,
              },
            },
          ],
        }}
      />
    </>
  );
};

export default AgGridReportComponent;
